import ChatButton from "@/chatbot-library/ChatButton"
import ChatText from "@/chatbot-library/ChatText"
import store from "@/store"

let chat = [
  new ChatText("welcome",
    {
      content: "Vous souhaitez demander une offre de reprise de votre véhicule ? C'est très simple.",
      next: "description"
    },
    { delay: 0 }
  ),

  new ChatText("description",
    {
      content: "Pour cela, nous avons tout d'abord besoin de quelques informations.",
      next: "ready"
    },
  ),

  new ChatText("ready",
    {
      content: "Êtes-vous prêt ?",
      actions: [
        new ChatButton(
          { label: "Commencer" },
          {
            next: "firstname-request",
            callback: () => store.commit("tradeinOfferRequest/flow/setStartedAt", new Date())
          }
        )
      ]
    }
  ),

  new ChatText("firstname-request",
    {
      content: "Quel est votre prénom ?",
      next: "lastname-request"
    },
  ),

  new ChatText("lastname-request",
    {
      content: "Quel est votre nom ?",
      next: "email-request"
    },
  ),

  new ChatText("email-request",
    {
      content: "Quel est votre adresse email ?",
      next: "introduce-yourself"
    },
  ),

  new ChatText("introduce-yourself",
    {
      content: "Votre demande d'une offre de reprise en ligne est à présent terminée.",
      next: "goodbye"
    }
  ),

  new ChatText("goodbye",
    { content: "À bientôt et merci !" }
  )
]

export default {
  entry: "welcome",
  chat
}
